export const glider = [
	[5, 10],
	[6, 11],
	[7, 11],
	[7, 10],
	[7, 9],
];

export const toad = [
	[9, 9],
	[9, 10],
	[9, 11],
	[8, 10],
	[8, 11],
	[8, 12],
];

export const beacon = [
	[5, 7],
	[5, 8],
	[6, 7],
	[6, 8],
	[7, 9],
	[8, 9],
	[8, 10],
	[7, 10],
];

export const beehive = [
	[7, 9],
	[7, 10],
	[8, 8],
	[9, 9],
	[9, 10],
	[8, 11],
];
